import React from 'react';
import { ReactiveBase } from '@appbaseio/reactivesearch';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { injectGlobal } from 'emotion';
import Footer from 'marketplace-footer';
import 'marketplace-footer/build/static/css/index.css';

import Home from './pages/Home';
import { APP, CRED } from './constants';

// eslint-disable-next-line
injectGlobal`
* {
    margin: 0;
	font-family: "Open Sans", "Lato", "Montserrat", "Muli", sans-serif;
  }
`;

const App = () => (
	<ReactiveBase app={APP} credentials={CRED}>
		<Router>
			<Switch>
				<Route component={Home} />
			</Switch>
		</Router>
		<Footer price="$69" url="https://gumroad.com/l/QEcYE" />
	</ReactiveBase>
);

export default App;
